module.exports = __webpack_public_path__ + "img/HeBo Trailers-22.3f8b2a2c.jpg";